import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import { classNames } from '../../utils/classNames';

const FormData = ({ setLogo, logo }) => {
	const [errorLogo, setErrorLogo] = useState('');

	// Función de aceptación de tipo de imagen
	const onDrop = (acceptedFiles) => {
		const file = acceptedFiles[0];

		if (!file) {
			setLogo(null);
			return;
		}

		// Validar el tipo de archivo
		if (file.type !== 'image/png') {
			setLogo(null);
			setErrorLogo('El archivo debe ser un .png');
			return;
		}

		// Validar el tamaño del archivo
		if (file.size > 500 * 1024) {
			// 500kb
			setLogo(null);
			setErrorLogo('El archivo no debe exceder 500kb');
			return;
		}

		// Leer el archivo para obtener las dimensiones de la imagen
		const reader = new FileReader();
		reader.onload = (e) => {
			const img = new Image();
			img.onload = () => {
				if (img.width > 500 || img.height > 500) {
					setLogo(null);
					setErrorLogo('La imagen debe ser menor a 500px x 500px');
				} else {
					setLogo(file);
					setErrorLogo('');
				}
			};
			img.src = e.target.result;
		};
		reader.readAsDataURL(file);
	};

	return (
		<Dropzone onDrop={onDrop}>
			{({ getRootProps, getInputProps, isDragActive }) => (
				<div
					{...getRootProps()}
					className={classNames(
						'flex min-h-[120px] cursor-pointer flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed px-4 py-8 text-center transition',
						isDragActive
							? 'border-sky-400 bg-sky-50'
							: 'border-zinc-300 bg-zinc-50/60 hover:border-sky-300 hover:bg-zinc-50',
					)}
				>
					<input {...getInputProps()} />
					{logo ? (
						<p className='text-xs font-medium text-emerald-700'>
							<b>Imagen cargada con éxito:</b> {logo.name}
						</p>
					) : (
						<p className='text-xs text-zinc-500'>
							Arrastre el archivo o haz clic aquí para seleccionar el logo de la
							institución
						</p>
					)}
					{errorLogo && <p className='text-xs text-rose-600'>{errorLogo}</p>}
				</div>
			)}
		</Dropzone>
	);
};

export default FormData;